module.exports = __webpack_public_path__ + "img/home-four-3.3f8ce045.jpg";